import InstantSearchFilters from './filters';
import AutoComplete from './autoComplete/autoComplete';

import { useSearchBox } from 'react-instantsearch';

import useIsSticky from '@javascript/lib/hooks/useIsSticky';
import useModal from '@javascript/lib/hooks/useModal';
import { useCustomClearRefinements } from '@javascript/lib/hooks/useCustomClearRefinements';

import classNames from 'classnames';

import { useState, type LegacyRef } from 'react';

import Analytics from '@javascript/lib/analytics';

import type { HasMotabilityState } from '@javascript/types/InstantSearch';

const InstantSearchHeader = ({ isMotability }: HasMotabilityState) => {
  const {
    ref: modalRef,
    maskClickHandlers,
    openModal,
    closeModal,
  } = useModal();
  const { ref, isSticky } = useIsSticky();
  const { query, refine } = useSearchBox();
  const clearFilters = useCustomClearRefinements();
  const [inputValue, setInputValue] = useState(query);

  const onSuggestionSelect = (value: string | null) => {
    // wipe the filters when a new search is made
    clearFilters.refine();
    // Analytics
    Analytics.trackEvent('click_cta', {
      label: `Instant search - serps - ${value}`,
    });
    // if no value is selected, show all vehicles
    refine(value || '');

    closeModal();
  };

  const handleInputChange = (newValue: string) => {
    setInputValue(newValue);
  };

  return (
    <>
      <div
        className="ac-instant-search__header--wrapper"
        ref={ref as LegacyRef<HTMLDivElement>}
      >
        <div
          className={classNames('ac-instant-search__header ch-pv--3 ch-ph--2', {
            'ac-instant-search__header--sticky': isSticky,
          })}
        >
          <div className="ac-instant-search__header-container ch-relative ch-display--flex ch-mh--auto">
            <input
              className="ac-autocomplete__input--dummy ch-flex--auto ch-form__control ch-bc--grey-3 ch-fs--3 ch-fw--500 ch-pl--8"
              onFocus={(e) => {
                e.currentTarget.blur();
                openModal();
              }}
              placeholder="Search"
              readOnly
              type="text"
              value={inputValue}
            />
            <InstantSearchFilters isMotability={isMotability} />
          </div>
        </div>
      </div>
      <hr className="ch-mh--2 ch-bg--grey-3 sm:ch-display--none" />
      <dialog {...maskClickHandlers} ref={modalRef}>
        <AutoComplete
          closeAutoComplete={closeModal}
          onInputChange={handleInputChange}
          onSuggestionSelect={onSuggestionSelect}
        />
      </dialog>
    </>
  );
};

export default InstantSearchHeader;
